import script from "./PageTrackerHouseTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTrackerHouseTasks.vue?vue&type=script&setup=true&lang=js"

import "./PageTrackerHouseTasks.vue?vue&type=style&index=0&id=1c519518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c519518"]])

export default __exports__